export const initialState = {
    name: {
        az: '',
        en: '',
        ru: ''
    }
};
